module.exports = __webpack_public_path__ + "static/icon-circle-silverware-aefe31b1ef423cb5acf4b49e7bb77c18.png";